import {
  apiGetTrainings,
  apiCopyAssessmentFile
} from '../../common/api/assessment'

const fetchTrainings = (schoolOrganisationFilter = false) => ({
  requestPrefix: 'TRAININGS:FETCH',
  request: () =>
    apiGetTrainings(schoolOrganisationFilter, {
      include:
        'assessment_file.details,assessment_file.timestamps,assessment_file.student_type.account,assessment_file.student_type.account.names,assessment_file.contributions,assessment_file.contributors,assessment_file.contributor,assessment_file.account.names,assessment_file.account.avatar,assessment_file.works,assessment_file.work.medium.thumb'
    })
})

const filterToSchoolOrganisation = () => ({
  type: 'TRAININGS:FILTER_SCHOOL_ORGANISATION'
})

const filterToAll = () => ({
  type: 'TRAININGS:FILTER_ALL'
})

const copyTraining = id => ({
  requestPrefix: 'TRAININGS:COPY',
  request: () => apiCopyAssessmentFile(id)
})

export { fetchTrainings, copyTraining, filterToSchoolOrganisation, filterToAll }
